/// <reference path="../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var ModalTranslations = /** @class */ (function () {
        function ModalTranslations() {
        }
        ModalTranslations.config = function ($translateProvider) {
            var _a;
            var keys = ap.Constants.translationKeys.modals;
            var englishTable = (_a = {},
                _a[keys.cancelButtons.cancel] = 'Cancel',
                _a[keys.cancelButtons.close] = 'Close',
                _a[keys.cancelButtons.no] = 'No',
                _a[keys.saveButtons.ok] = 'OK',
                _a[keys.saveButtons.save] = 'Save',
                _a[keys.saveButtons.yes] = 'Yes',
                _a[keys.saving] = 'Saving...',
                _a);
            $translateProvider.translations('en', englishTable);
        };
        return ModalTranslations;
    }());
    app.ModalTranslations = ModalTranslations;
    angular.module('app')
        .config(['$translateProvider', ModalTranslations.config]);
})(app || (app = {}));
